import { ContentInstance } from 'src/integration/api/ui/ContentInstance';
import { Ui } from 'src/integration/api/ui/Ui';
import { hasValue, orElse, whenHasValue } from 'src/shared/NullUtil';
import { getUltraDocumentContainer } from 'src/shared/wysiwyg/ultra/get-ultra-document-container';

export class LearnUltraUtil {

    /** Determine if the current window context is a learn ultra context. */
    public static isUltra(window: Window): boolean {
        return window.location.pathname.toLowerCase().startsWith('/ultra/');
    }
}

export function isUltraUi({ config }: Ui): boolean {
    return config.platformName === 'learn' &&
        orElse(whenHasValue(config.platformUi, (ui) => ui.startsWith('ultra')), false);
}

export function renderPolicyFilter(ci: ContentInstance): boolean {
    const id = ci.getId();
    if (id.startsWith('bbml-editor-id')) {
        // File viewer doesn't have any metadata, thus only AF icon metadata must be used for render policy
        if (getUltraDocumentContainer(ci.$el[0]).length > 0) {
            // This is the new Ultra document editor
            return ci.$el.parent()
                .find(`*[data-ally-show="alternativeformats"][data-ally-content-ref="${id}"]`).length === 1;
        }
        return ci.$el.parents('bb-file-viewer')
            .find(`*[show-alternative-formats-link="true"][content-id="${id}"]`)
            .length === 1;
    }

    // RTE files have embedded render policy metadata in attributes
    const metadata = whenHasValue(
        ci.$el.parents('*[data-bbfile]').attr('data-bbfile'), JSON.parse
    );

    return !(hasValue(metadata) &&
        metadata.render === 'inlineOnly' &&
        metadata.resourceUrl === ci.getFilePreviewUrl());
}
